import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider, useAuth } from './contexts/AuthContext';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
import ApiRequestPage from './pages/ApiRequestPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import LandingPage from './pages/LandingPage';
import PricingPage from './pages/PricingPage';
import FaqPage from './pages/FaqPage';
import HowItWorksPage from './pages/HowItWorksPage';
import BlogPage from './pages/BlogPage';
import SupaserverVsFirebase from './pages/blog/SupaserverVsFirebase';
import SupaserverVsSupabase from './pages/blog/SupaserverVsSupabase';
import SupaserverVsXano from './pages/blog/SupaserverVsXano';

function AppRoutes() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-lg">
              <Routes>
          <Route 
            path="/" 
            element={<LandingPage />} 
          />
          <Route 
            path="/login" 
            element={
              isAuthenticated ? <Navigate to="/api-request?demo=true" replace /> : <LoginPage />
            } 
          />
          <Route 
            path="/signup" 
            element={
              isAuthenticated ? <Navigate to="/api-request?demo=true" replace /> : <SignupPage />
            } 
          />
          <Route 
            path="/verify-email" 
            element={<VerifyEmailPage />} 
          />
          <Route 
            path="/api-request" 
            element={<ApiRequestPage />} 
          />
          <Route 
            path="/pricing" 
            element={<PricingPage />} 
          />
          <Route 
            path="/faq" 
            element={<FaqPage />} 
          />
          <Route 
            path="/how-it-works" 
            element={<HowItWorksPage />} 
          />
          <Route 
            path="/blog" 
            element={<BlogPage />} 
          />
          <Route 
            path="/blog/supaserver-vs-firebase" 
            element={<SupaserverVsFirebase />} 
          />
          <Route 
            path="/blog/supaserver-vs-supabase" 
            element={<SupaserverVsSupabase />} 
          />
          <Route 
            path="/blog/supaserver-vs-xano" 
            element={<SupaserverVsXano />} 
          />
        </Routes>
    </div>
  );
}

function App() {
  // Google OAuth Client ID - замените на ваш Client ID из Google Cloud Console
  const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <AppRoutes />
        </Router>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;